// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"185":"slide-fullsize-vid","224":"slide-img-text","619":"slide-simple-text","851":"slide-highlighted-numbers","977":"slide-quote"}[chunkId] + "." + {"185":"29ef4a7a","224":"30e61016","619":"612b022c","851":"386f5bef","977":"59d35d9f"}[chunkId] + ".css";
};